import { ActionContext, ActionTree } from "vuex";
import { AppState } from "@/store/mainStore/state";
import { RootState } from "@/store/root.state";
import PageContext from "@/entities/page.context";
import { Modal } from "@/entities/modal";

class Helper {
  static async setPageContext(actionContext: ActionContext<AppState, RootState>, payload: PageContext): Promise<void> {
    actionContext.commit('setPageContext', payload);
  }
  static async setMobileView(actionContext: ActionContext<AppState, RootState>, payload: boolean): Promise<void> {
    actionContext.commit('setMobileView', payload);
  }
  static async setModal(actionContext: ActionContext<AppState, RootState>, payload: Modal): Promise<void> {
    actionContext.commit('setModal', payload);
  }
  static async updateMarketResult(actionContext: ActionContext<AppState, RootState>, payload:  Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns: string}>): Promise<void> {
    actionContext.commit('updateMarketResult', payload);
  }
}
export const actions: ActionTree<AppState, RootState> = {
  async setPageContext(actionContext: ActionContext<AppState, RootState>, payload: PageContext): Promise<void> {
    await Helper.setPageContext(actionContext, payload);
  },
  async setMobileView(actionContext: ActionContext<AppState, RootState>, payload: boolean): Promise<void> {
    await Helper.setMobileView(actionContext, payload);
  },
  async setModal(actionContext: ActionContext<AppState, RootState>, payload: Modal): Promise<void> {
    await Helper.setModal(actionContext, payload);
  },
  async updateMarketResult(actionContext: ActionContext<AppState, RootState>, payload:  Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns: string}>): Promise<void> {
    await Helper.updateMarketResult(actionContext, payload);
  }
}